(ns hai.account.refer.routes
  (:require
   [hai.ui.components :as c]
   [hai.ui.icons :as icons]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Refer & earn credits 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/account/refer" {:name :account/refer
                      ::routing/window-title "Refer & earn credits"
                      :label "Refer & earn credits"
                      :icon icons/outlined-payment
                      :view page}]])
